module.exports = __webpack_public_path__ + "static/media/c1.76466784.jpeg";